import { IGroupTrackingInfo, ITransportDetailSection } from 'types/transport'
import { airStatus, stepStatusSelect } from 'data/transport';
import DetailInfoArea from 'components/transport/DetailInfoArea';
import { useEffect, useState } from 'react';
import { jsonAxios } from 'components/axios';
import { groupByStation } from 'components/function';
import { ReactComponent as Plane } from 'assets/transport/detail/plane.svg'
import Loading from 'components/common/Loading';

const InTransit = ({ detailInfo, type, loading }: ITransportDetailSection) => {
    const [userToken, setUserToken] = useState<string>('');
    const [url, setUrl] = useState<string>('');
    const [list, setList] = useState<IGroupTrackingInfo[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (type === 'SEA' && detailInfo?.blNo) {
            getToken()
            const blNo = detailInfo?.blNo;
            setUrl(`mblNo=${blNo}`);
        }
        else {
            detailInfo?.detailInfo.trackingInfo &&
                detailInfo?.detailInfo.trackingInfo.length > 0 ?
                setList(groupByStation(detailInfo?.detailInfo.trackingInfo)) :
                setList([])
        }
    }, [detailInfo, type])

    const getToken = () => {
        jsonAxios.post('tokens').then(res => {
            if (res.data.code === 200) {
                setUserToken(res.data.data)
            }
        })
    }

    if (loading) return <div className='flex justify-center items-center h-96'><Loading /></div>

    return (
        <div className='flex flex-col justify-start items-start gap-6 px-10 py-6 text-lg'>
            <DetailInfoArea
                title='운송단계상태'
                value={stepStatusSelect.find(arr => arr.value === String(detailInfo.stepStatus))?.label || ''}
            />
            {
                type === 'SEA' ?
                    detailInfo?.bookingNumber && userToken && url && (
                        <div className="relative w-full h-[800px]">
                            {isLoading && (
                                <div className="z-10 absolute inset-0 flex justify-center items-center bg-white">
                                    <p className="text-black">해상트래킹 불러오는 중...</p>
                                </div>
                            )}
                            <iframe
                                title="Tracking Information"
                                src={`https://insight.seavantage.com/cargo/tracking?userToken=${userToken}&${url}`}
                                className="w-full h-full"
                                onLoad={() => setIsLoading(false)}
                            />
                        </div>
                    ) :
                    <div className='flex flex-col gap-3 w-full'>
                        {
                            list.map((item, idx) => (
                                <div className='flex items-start' key={idx}>
                                    <div className='w-[122px]'>
                                        <div className={`flex items-center text-2xl text-white px-4 rounded font-semibold h-20 ${idx === 0 ? 'bg-primary' : 'bg-[#9D9EB7]'}`}>{item.station}</div>
                                        <div className='flex items-center gap-2'>
                                            <Plane />
                                            <p className='font-semibold text-lg'>{item.flight_number}</p>
                                        </div>
                                    </div>
                                    <div className='flex flex-col flex-1 gap-3'>
                                        {
                                            item.list.map((items, index) => {
                                                const matched = airStatus.find(arr => arr.code === items.status);
                                                const Icon = (idx === 0 && index === 0) ? matched?.IconOn : matched?.IconOff;
                                                return (
                                                    <div className='flex justify-between items-center shadow-[0px_0px_4px_rgba(0,0,0,0.1)] rounded h-20 text-base' key={index}>
                                                        <div className='flex flex-[2.0] items-center gap-3 px-6'>
                                                            <div className='w-10 shrink-0'>
                                                                {Icon && <Icon />}
                                                            </div>
                                                            <p>{airStatus.find(arr => arr.code === items.status)?.name}({items.status})</p>
                                                        </div>

                                                        <div className='flex-[1.5]'>
                                                            <p>{items.actual_date}</p>
                                                        </div>

                                                        <div className='flex flex-col flex-[1.0] px-6 leading-none'>
                                                            <p className='text-[#9D9EB7] text-sm'>무게</p>
                                                            <p>{items.weight ? `${items.weight}kg` : '-'}</p>
                                                        </div>

                                                        <div className='flex flex-col flex-[1.0] px-6 leading-none'>
                                                            <p className='text-[#9D9EB7] text-sm'>화물갯수</p>
                                                            <p>{items.piece ?? '-'}</p>
                                                        </div>

                                                        <div className='flex flex-col flex-[2.0] px-6 leading-none'>
                                                            <p className='text-[#9D9EB7] text-sm'>이벤트</p>
                                                            <p>{items.event}</p>
                                                        </div>

                                                        <div className='flex flex-col flex-[2.5] px-6 leading-none'>
                                                            <p className='text-[#9D9EB7] text-sm'>비고</p>
                                                            <p>{airStatus.find(arr => arr.code === items.status)?.description}</p>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
            }
        </div>
    )
}

export default InTransit